// removed by extract-text-webpack-plugin
module.exports = {"cards":"dh-metoo-stortinget-cards","card":"dh-metoo-stortinget-card","card__info":"dh-metoo-stortinget-card__info","card__number":"dh-metoo-stortinget-card__number","card__text":"dh-metoo-stortinget-card__text","card__icons":"dh-metoo-stortinget-card__icons","card__person":"dh-metoo-stortinget-card__person","card__icon":"dh-metoo-stortinget-card__icon","card__icon--active":"dh-metoo-stortinget-card__icon--active","spacer":"dh-metoo-stortinget-spacer"};


//////////////////
// WEBPACK FOOTER
// ./src/shared/cards/index.css
// module id = 14
// module chunks = 0